// importing a specificmodule from the firebase library called app
// app package = core of firebase sdk
// firebase module == broken up into packages
// firebase allows multiple apps to be connected to a project
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyD416-kqWcKCnHm7Q0BqRJNpACwDNSwZyY',
  authDomain: 'care-on-wheels-123.firebaseapp.com',
  projectId: 'care-on-wheels-123',
  storageBucket: 'care-on-wheels-123.appspot.com',
  messagingSenderId: '759603322913',
  appId: '1:759603322913:web:8b07aaf5e8ffcf9a228360',
};

// Initialize Firebase by connecting to it
firebase.initializeApp(firebaseConfig);

const auth = firebase.auth(); // value = object returned by the firebase.auth function
const db = firebase.firestore();
// firestore function returns an obj with methods & properties for interacting with the db

// const storage = firebase.storage();
// ll tasks related to storage can be found under this method

const usersCollection = db.collection('users');

export { // named exports
  auth,
  db,
  usersCollection,
  // storage, // obj exposes the cloud storage functions to our components
};

// creating references to the auth and forestore services then we'll export the references
// allows any componenet to access the service without having to create a reference itself
